module.exports = __webpack_public_path__ + "img/art-test-icon5.4af6bb9f.png";